import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AppProvider } from "./AppContext";
import MainPage from "./Pages/MainPage";
import Header1 from "./Pages/Header1";
import Header2 from "./Pages/Header2";
import Header3 from "./Pages/Header3";
import Category from "./Pages/Category";
import Brand from "./Pages/Brand";
import New from "./Pages/New";
import Profile from "./Pages/Profile";
import Cart from "./Pages/Cart";
import Favorite from "./Pages/Favorite";
import ProductCard from "./Pages/ProductCard";
import ProductPage from "./Pages/ProductPage";
import Discount from "./Pages/Discount";
import NewDubaiPerfumes from "./Pages/NewDubaiPerfumes";
import BottomBlock from "./Pages/BottomBlock";
import CheckOut from "./Pages/CheckOut";

//for local
//export const MyDomain = "http://10.0.0.4/";
//export const MyDomain = "https://localhost:44326/";

//export const MyDomain = "http://172.20.10.11/";
export const MyDomain =
  "https://makeup-csharp.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ overflowX: "hidden", maxWidth: "100%" }}>
      <ScrollToTop />
      {location.pathname !== "/checkout" && <Header1 />}
      <div
        style={{
          paddingLeft:
            windowWidth <= 1024
              ? "0%"
              : windowWidth <= 1920
                ? "15%"
                : windowWidth <= 2560
                  ? "25%"
                  : windowWidth <= 3840
                    ? "30%"
                    : "35%",
          paddingRight:
            windowWidth <= 1024
              ? "0%"
              : windowWidth <= 1920
                ? "15%"
                : windowWidth <= 2560
                  ? "25%"
                  : windowWidth <= 3840
                    ? "30%"
                    : "35%",
          justifyContent: "center",
          fontFamily: "Droid Arabic Kufi, sans-serif",
          overflowX: "hidden",
          maxWidth: "100%",
        }}
      >
        {location.pathname !== "/checkout" && <Header2 />}
        {location.pathname !== "/checkout" && <Header3 />}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/category" element={<Category />} />
          <Route path="/category/:categoryName" element={<Category />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="/brand/:brandName" element={<Brand />} />
          <Route path="/new" element={<New />} />
          <Route path="/new-dubai-perfumes" element={<NewDubaiPerfumes />} />

          <Route path="/profile" element={<Profile />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/favorite" element={<Favorite />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/discount" element={<Discount />} />

          <Route path="/checkout" element={<CheckOut />} />
        </Routes>

        {location.pathname !== "/checkout" && <BottomBlock />}
      </div>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
}

export default App;
